import * as React from 'react';
import { Alert } from "react-bootstrap";
import { connect } from 'react-redux';
import { Route } from "react-router";
import { postToController } from '../../actions/apiActions';
import { hideLoadingScreen, showLoadingScreen } from '../../actions/fullscreenActions';
import { avsValidateBankingDetails, clearMetadata, getLifeBankingDetailsPage, getSpecialDebitDays, saveBankingDetails, setCollectionToSchedule, updateDebitOrderDate } from "../../actions/lifePolicyActions";
import { showChangeCreditCard } from '../../actions/modalActions';
import { navigateTo } from '../../actions/navigationActions';
import { getUserBankingDetails, submitScheduleSpecialDebit, updateBankingDetails } from '../../actions/profileActions';
import { createQuoteFromPolicyCardUpdate, IveriSubmission } from '../../actions/salesActions';
import { LifeCollection } from '../../reducers/lifePolicyReducer';
import { CHANGE_BANKING_DETAILS, CHANGE_DEBIT_ORDER_DATE, LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE, LIFE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE, LIFE_PAYMENT_DETAILS, LIFE_SCHEDULE_SPECIAL_DEBIT } from '../../routes/routes';
import { ChangeDebitOrderDate } from "../BankingDetails/ChangeDebitOrderDate";
import { DebicheckValidate } from "../BankingDetails/DebicheckValidate";
import { DebitOrderDate } from "../BankingDetails/DebitOrderDate";
import { DebitOrderDetails } from "../BankingDetails/DebitOrderDetails";
import LifeChangeBankingDetails from '../BankingDetails/LifeChangeBankingDetails';
import { PaymentHistory } from "../BankingDetails/PaymentHistory";
import { ScheduleSpecialDebit } from "../BankingDetails/ScheduleSpecialDebit";
import { PolicyBanner } from "../PolicyBanner/PolicyBanner";
import './LifePaymentDeets.css';

class LifePaymentDeets extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            collectionPageAmount: 8,
            isInEdit: false,
            addPayment: false,
            editHolder: this.props.profile?.bankingDetails?.accountholder,
            editAccountNumber: "",
            currBank: this.props.profile?.bankingDetails?.bank,
            currBranch: this.props.profile?.bankingDetails?.branchName,
            currAccountType: this.props.profile?.bankingDetails?.bankAccountType,
            bankInfoList: [],
            accountTypeList: [],
            branchList: [],
            debitDayList: [],
            selectedBank: {},
            selectedBranch: {},
            selectedAccountType: {},
            selectedDebitDay: {},
            bankingDetailsEmpty: true,
            branchDetailsEmpty: true,
            bankDropdownOpen: false,
            branchDropdownOpen: false,
            accountTypeDropdownOpen: false,
            debitDayDropdownOpen: false,
            paymentHistory: [],
            moreCollectionsAvailable: true,
            showScheduleDebit: false,
            bankInfoLoading: false,
            showChangedDebitOrderDateNotification: null,
            showBankingNotification: null,
            showBankingDebitOrderNotification: null,
            newDebitOrderDateValue: '',
            newDebitOrderDateText: '',
            newBankingDetails: {},
            bankingDetails: {},
            lifeChangeBankingDetailsComponent: () => {},
            debitOrderDate: {
                when: this.props.lifePolicy.policy?.when,
                startDate: this.props.lifePolicy.policy?.startDate,
                monthsActive: this.props.lifePolicy.policy?.monthsActive,
            }
        };
        
        this.handleConfirmBankingDetails = this.handleConfirmBankingDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.showFieldUpdate = this.showFieldUpdate.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.handleEditInfo = this.handleEditInfo.bind(this);
        this.saveEdit = this.saveEdit.bind(this)
        this.addNewPayment = this.addNewPayment.bind(this);
        this.handleBankDropdownToggle = this.handleBankDropdownToggle.bind(this);
        this.handleBankSelection = this.handleBankSelection.bind(this);
        this.handleBranchDropdownToggle = this.handleBranchDropdownToggle.bind(this);
        this.handleBranchSelection = this.handleBranchSelection.bind(this);
        this.handleAccountTypeDropdownToggle = this.handleAccountTypeDropdownToggle.bind(this);
        this.handleAccountTypeSelection = this.handleAccountTypeSelection.bind(this);
        this.handleUpdateBankDetails = this.handleUpdateBankDetails.bind(this);
        this.handleRedirectTo = this.handleRedirectTo.bind(this);
        this.handleChangeDebitOrderDate = this.handleChangeDebitOrderDate.bind(this);
        this.handleGetMoreCollections = this.handleGetMoreCollections.bind(this);
        this.handlePersistChangeDebitOrderDate = this.handlePersistChangeDebitOrderDate.bind(this);
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
        this.handleScheduleSpecialDebitFromAlert = this.handleScheduleSpecialDebitFromAlert.bind(this);
        this.dismissShowChangedDebitOrderDateNotification = this.dismissShowChangedDebitOrderDateNotification.bind(this);
        this.handleSubmitScheduleSpecialDebit = this.handleSubmitScheduleSpecialDebit.bind(this);
        this.handleDebicheck = this.handleDebicheck.bind(this);
        this.handleSaveBankingBack = this.handleSaveBankingBack.bind(this);
        this.handleRetryPayment = this.handleRetryPayment.bind(this);
        this.handleAvsValidateBankingDetails = this.handleAvsValidateBankingDetails.bind(this);
        this.dismissShowChangedBankingNotification = this.dismissShowChangedBankingNotification.bind(this);
        this.dismissShowChangedBankingDebitOrderNotification = this.dismissShowChangedBankingDebitOrderNotification.bind(this);
    }

    async componentDidMount() {
        this.props.dispatchResetMetadata();
        this.props.dispatchGetLifeBankingDetailsPage(this.state.collectionPageAmount, 0);
        this.props.dispatchGetSpecialDebitDays();
        await this.getBankInfo();
        
        let showScheduleDebit = false;
        
        const collections: Array<LifeCollection> = this.props.lifePolicy?.policy?.collections?.map((collection: LifeCollection) => {
            if (collection.status == "Payment failed") {
                showScheduleDebit = true;
            }
            return {
                amount: collection.amount,
                status: collection.status,
                date: collection.actionDate,
                id: collection.id,
                isSpecialDebit: collection.isSpecialDebit,
            };
        });

        await this.setState({
            ...this.state,
            paymentHistory: collections,
            showScheduleDebit,
            moreCollectionsAvailable: this.props.lifePolicy.policy?.collections?.length == this.state.collectionPageAmount,
        });
        
        const mandateStatus = this.props.lifePolicy?.policy?.mandateStatus;
        if (mandateStatus == 'pending') {
            this.setState({
                ...this.state,
                showChangedDebitOrderDateNotification: true,
            })
        }

        if (this.props.router.location.pathname === LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE) {
            this.handleRedirectTo(CHANGE_BANKING_DETAILS);
        }

        const { lifePolicy } = this.props;
        let policy = lifePolicy.policy;
        let accountNumber = '';
        let accountType = '';
        let branchCode = '';
        let bankName = '';
        let premiumPayerType = '';
        if (policy.bankingDetails) {
            accountNumber = policy.bankingDetails.accountNumber;
            accountType = policy.bankingDetails.accountType;
            branchCode = policy.bankingDetails.branchCode;
            bankName = policy.bankingDetails.bankName;
            premiumPayerType = policy.premiumPayer.parentId === policy.primaryContactId ? 'Policyholder' : 'Someone else';
        }

        let bankingDetails = {
            accountNumber,
            accountType,
            branchCode,
            bankName,
            premiumPayerType,
        };

        if (premiumPayerType === 'Someone else') {
            bankingDetails['relationship'] = policy.premiumPayer.party.relationship;
            bankingDetails['name'] = policy.premiumPayer.party?.name;
            bankingDetails['surname'] = policy.premiumPayer.party?.surname;
            bankingDetails['idNumber'] = policy.premiumPayer.party?.idNumber;
            bankingDetails['notes'] = policy.premiumPayer.party?.notes;
            bankingDetails['title'] = policy.premiumPayer.party?.title;
            bankingDetails['email'] = policy.premiumPayer.party?.email;
            bankingDetails['phoneNumber'] = policy.premiumPayer?.party.phoneNumber;
        }

        this.setState({
            bankingDetails,
        });
    }
    
    async handleConfirmBankingDetails(e: any) {
        this.props.dispatchClearBankingDetailsErrors();
        if (this.props.lifePolicy.policy?.paymentType?.toLowerCase() != 'debicheck') {
            const bankingDetails = {
                accountNumber: e.accountNumber,
                accountType: e.accountType,
                bankName: e.bankName,
                branchCode: e.branchCode,
            }
            this.setState({
                bankingDetails,
            });
            await this.props.dispatchSaveBankingDetails(bankingDetails);
        } else {
            if (this.props.router.location.pathname == LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE) {
                await this.props.dispatchSaveBankingDetails(this.state.newBankingDetails);
            } else {
                this.setState({
                    newBankingDetails: e,
                });
                this.handleRedirectTo(LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE);
            }
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
    }

    handleRedirectTo(destination) {
        this.props.redirectTo(destination);
    }

    async handleUpdateBankDetails() {
        await this.props.dispatchShowLoadingScreen();
        await this.props.dispatchCreateQuoteFromPolicy();
        await this.props.dispatchHideLoadingScreen();
    }

    async showFieldUpdate(e: any) {
        let value = e.target.id;
        this.props.dispatchShowUpdateCustomerInfo(value);
    }

    async getBankInfo() {
        await this.setState({
            bankInfoLoading: true,
        });
        try {
            await postToController(this.props.dispatch, 'GetLifeBankInfo', JSON.stringify({})).then(async (response) => {
                await this.setState({
                    bankList: response.bankInfoList,
                    accountTypeList: response.bankAccountTypeList,
                    debitDayList: response.debitOrderDateList,
                });
                return true;
            });
        } finally {
            await this.setState({
                bankInfoLoading: false,
            });
        }
    }

    async cancelNewPayment() {
        await this.setState({ addPayment: false });
    }

    cancelEdit(e: any) {
        this.setState({
            isInEdit: false,
        });
    }

    async saveEdit(e: any) {
        await this.props.dispatch(updateBankingDetails(this.state));
        await this.props.dispatch(getUserBankingDetails());
        this.setState({ isInEdit: false });
    }

    async handleChangeDebitOrderDate(e: any) {
        this.handleRedirectTo(CHANGE_DEBIT_ORDER_DATE); 
    }

    async handleDebicheck(value: any, text: any) {
        this.setState({
            newDebitOrderDateValue: value,
            newDebitOrderDateText: text,
        });

        if (this.props.lifePolicy.policy?.paymentType?.toLowerCase() != 'debicheck') {
            this.handlePersistChangeDebitOrderDate(null, value, text);
        } else {
            this.handleRedirectTo(LIFE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE);
        }
        
    }
    
    async handlePersistChangeDebitOrderDate(e: any, value = null, text = null) {
        if (value == null) {
            value = this.state.newDebitOrderDateValue;
        }
        if (text == null) {
            text = this.state.newDebitOrderDateText;
        }

        this.props.dispatchPersistDebitOrderDate(value, text);
        
        this.setState({
            ...this.state,
            showChangedDebitOrderDateNotification: true,
        });

        this.handleRedirectTo(LIFE_PAYMENT_DETAILS);
    }

    async handleSaveBankingBack() {
        this.handleRedirectTo(CHANGE_BANKING_DETAILS);
    }
    
    async handleGetMoreCollections(e: any) {
        const skip = this.props.lifePolicy.policy.collections.length;
        const responseLength = await this.props.dispatchGetLifeBankingDetailsPage(this.state.collectionPageAmount, skip, true);
        this.setState({
            moreCollectionsAvailable: responseLength == this.state.collectionPageAmount
        })
    }
    
    async handleEditInfo(e: any) {
        const bankingDetails = this.props.lifePolicy.policy.bankingDetails;
        let currBank = bankingDetails?.bankName;
        let bank = this.state.bankList?.filter(function (item) {
            return item.description === currBank
        });

        this.handleRedirectTo(CHANGE_BANKING_DETAILS);

        if (bank) {
            this.setState({ selectedBank: bank[0] });
        }

        this.setState({ isInEdit: true });
    }

    async addNewPayment(e: any) {
        await this.setState({ addPayment: true });
    }

    async handleBankSelection(e: any) {
        let bank = this.state.bankList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedBank: bank[0] });
        await this.setState({ branchList: bank[0].bankBranches });
        await this.setState({ branchDetailsEmpty: false });
    }

    async handleBankDropdownToggle(e: any) {
        await this.setState({
            bankDropdownOpen: !this.state.bankDropdownOpen
        });
    }

    async handleBranchSelection(e: any) {
        let branch = this.state.branchList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedBranch: branch[0] });
    }

    async handleBranchDropdownToggle(e: any) {
        await this.setState({
            branchDropdownOpen: !this.state.branchDropdownOpen
        });
    }

    async handleAccountTypeSelection(e: any) {
        let accountType = this.state.accountTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedAccountType: accountType[0] });
        await this.setState({ branchDetailsEmpty: false });
    }

    async handleAccountTypeDropdownToggle(e: any) {
        await this.setState({
            accountTypeDropdownOpen: !this.state.accountTypeDropdownOpen
        });
    }
    
    dismissShowChangedDebitOrderDateNotification() {
        this.setState({
            ...this.state,
            showChangedDebitOrderDateNotification: false,
        })
    }

    dismissShowChangedBankingNotification() {
        this.setState({
            ...this.state,
            showBankingNotification: false,
        })
    }

    dismissShowChangedBankingDebitOrderNotification() {
        this.setState({
            ...this.state,
            showBankingDebitOrderNotification: false,
        })
    }

    async handleSubmitScheduleSpecialDebit(date: string) {
        this.props.dispatchSubmitScheduleSpecialDebit(date);
    }
    
    async handleScheduleSpecialDebit(e: any) {
        const paymentHistory = this.state.paymentHistory.filter((p) => p.id === e)[0];
        this.props.dispatchSetCollectionToSchedule(paymentHistory);
        this.handleRedirectTo(LIFE_SCHEDULE_SPECIAL_DEBIT);
    }
    
    async handleScheduleSpecialDebitFromAlert(e: any) {
        const latestPaymentHistory = this.state.paymentHistory.filter((p) => p.status === "Payment failed")[0];
        
        await this.handleScheduleSpecialDebit(latestPaymentHistory.id);
    }

    async handleRetryPayment(e: any) {
        const collectionId = e;
    }

    async handleAvsValidateBankingDetails(e: any) {
        this.props.dispatchAvsValidateBankingDetails(e);
    }

    public render() {
        const showDebitOrderNotif = this.state.showChangedDebitOrderDateNotification ? true : false;
        const showBankingNotif = this.state.showBankingDebitOrderNotification ? true : this.state.showBankingDebitOrderNotification != false && (this.props.lifePolicy.metadata?.bankingDetails?.new == true || this.props.lifePolicy.policy.mandateStatus == 'pending');
        const showNewBankingNotif = this.state.showBankingNotification != false && this.props.lifePolicy.metadata?.bankingDetails?.new == true;

        let accountHolder;

        if (this.props.lifePolicy?.policy?.premiumPayer.parentId === this.props.lifePolicy?.policy?.primaryContactId) {
            accountHolder = this.props.lifePolicy?.policy?.contact?.name
        } else {
            if (this.props.lifePolicy?.policy?.premiumPayer) {
                const premPayer = this.props.lifePolicy.policy.premiumPayer;
                accountHolder = premPayer.party.name + " " + premPayer.party.surname;
            }
        }

        return (
            <div className="life-payment-deets" id="LifePaymentDeets">
                <Route path={CHANGE_BANKING_DETAILS} exact={true} component={LifeChangeBankingDetails}/>

                <Route path={CHANGE_DEBIT_ORDER_DATE} exact={true} component={() =>
                    <>
                        <ChangeDebitOrderDate loading={this.state.bankInfoLoading} emitHandleChangeDebitOrderDate={this.handleDebicheck} debitOrderDateList={this.state.debitDayList} debitOrderDate={this.props.lifePolicy.policy.debitOrderDateFriendly}> </ChangeDebitOrderDate>
                    </>
                } />

                <Route path={LIFE_CHANGE_BANKING_DETAILS_DEBICHECK_VALIDATE} exact={true} component={() =>
                    <DebicheckValidate
                        emitHandleValidate={this.handleConfirmBankingDetails}
                        emitHandleBack={this.handleSaveBankingBack}
                        saving={this.props.lifePolicy.metadata?.bankingDetails?.saving}
                        title="DebiCheck"
                        error={this.props.lifePolicy.metadata?.bankingDetails?.error}
                        success={this.props.lifePolicy.metadata?.bankingDetails?.success}
                    ></DebicheckValidate>
                } />

                <Route path={LIFE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE} exact={true} component={() =>
                    <DebicheckValidate
                        emitHandleValidate={this.handlePersistChangeDebitOrderDate}
                        emitHandleBack={this.handleSaveBankingBack}
                        title="Change debit order date"
                        error={this.props.lifePolicy.metadata?.bankingDetails?.error}
                        success={this.props.lifePolicy.metadata?.bankingDetails?.success}
                    ></DebicheckValidate>
                } />
                
                <Route path={LIFE_SCHEDULE_SPECIAL_DEBIT} exact={true} component={() =>
                    <>
                        <ScheduleSpecialDebit 
                            premium={this.props.lifePolicy.collectionToSchedule?.amount}
                            saving={this.props.lifePolicy.metadata?.bankingDetails?.saving}
                            emitHandleScheduleSpecialDebit={this.handleScheduleSpecialDebit}
                            debitOrderDateList={this.props.lifePolicy.specialDebitDays}
                            disableMainForm={true}
                            bankInfoLoading={this.state.bankInfoLoading}
                            form={{
                                bankingDetails: this.state.bankingDetails,
                                accountTypeList: this.state.accountTypeList ? this.state.accountTypeList : [],
                                bankInfoList: this.state.bankList ? this.state.bankList : []
                            }}
                         />
                    </>
                } />

                <Route path={LIFE_PAYMENT_DETAILS} exact={true} component={() =>
                    <div className="row">
                        <div className="col-12 life-payment-deets__policy-banner">
                             <>
                                 { this.state.showScheduleDebit && 
                                    <Alert variant="warning" onClick={this.handleScheduleSpecialDebitFromAlert}>
                                        <div>
                                            <div className="d-inline-block mr-1">
                                                <img src="./Images/icon-notification.png" /> 
                                                <span className="ml-3">Schedule a special debit. </span>
                                            </div>
                                             <a className="d-inline-block" onClick={this.handleScheduleSpecialDebitFromAlert}> Click here.</a>
                                             <button className="float-right" onClick={this.handleScheduleSpecialDebitFromAlert}><img src="./Images/16-px.svg" /></button>
                                        </div>
                                    </Alert> 
                                 }
                             </>
                            <>
                                {(showDebitOrderNotif) &&
                                    <Alert onClose={this.dismissShowChangedDebitOrderDateNotification} variant="success" className="d-flex justify-content-between">
                                        You’ve successfully changed your debit order date, please confirm the debit order with your bank
                                        <button onClick={this.dismissShowChangedDebitOrderDateNotification}><img src="./Images/icons-navigation-close-24-px-white.svg" /></button>
                                    </Alert>
                                }
                            </>
                            <>
                                {(showBankingNotif) &&
                                    <Alert onClose={this.dismissShowChangedBankingDebitOrderNotification} variant="success" className="d-flex justify-content-between">
                                        You’ve successfully changed your banking details, please confirm the debit order with your bank
                                        <button onClick={this.dismissShowChangedBankingDebitOrderNotification}><img src="./Images/icons-navigation-close-24-px-white.svg" /></button>
                                    </Alert>
                                }
                            </>
                            <>
                                {(showNewBankingNotif) &&
                                    <Alert onClose={this.dismissShowChangedBankingNotification} variant="success" className="d-flex justify-content-between">
                                        You’ve successfully changed your banking details
                                        <button onClick={this.dismissShowChangedBankingNotification}><img src="./Images/icons-navigation-close-24-px-white.svg" /></button>
                                    </Alert>
                                }
                            </>
                        </div>
                        <div className="col-12 life-payment-deets__policy-banner">
                            <PolicyBanner policyName={this.props.lifePolicy.policy.name} nextDebitOrderDate={this.props.lifePolicy.policy.bankingDetails?.nextDebitOrderDate} title={"Livin' policy"} />
                        </div>
                        <div className="col-12 col-xl-6">
                            <div className="col-12 p-0 mb-3">
                                <DebitOrderDetails accountHolder={accountHolder} loading={this.props.lifePolicy.metadata?.bankingDetails?.loading} bankingDetails={this.props.lifePolicy.policy.bankingDetails} onEmitEditInfo={this.handleEditInfo} />
                            </div> 
                            <div className="col-12 p-0 mb-3">
                                <DebitOrderDate loading={this.props.lifePolicy.metadata?.bankingDetails?.loading} debitOrderDate={this.state.debitOrderDate} onEmitChangeDebitOrderDate={this.handleChangeDebitOrderDate} />
                            </div>
                        </div>
                        <div className="col-12 col-xl-6">
                            <PaymentHistory emitHandleRetryPayment={this.handleRetryPayment} loading={this.props.lifePolicy.metadata?.collection?.loading} moreCollectionsAvailable={this.state.moreCollectionsAvailable} paymentHistory={this.state.paymentHistory} emitHandleViewOlder={this.handleGetMoreCollections} emitHandleScheduleSpecialDebit={this.handleScheduleSpecialDebit} />
                        </div>
                    </div> 
                } />
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
        lifePolicy: state.lifePolicy,
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchCreateQuoteFromPolicy: () => dispatch(createQuoteFromPolicyCardUpdate()),
        dispatchIveriSubmission: (quote) => dispatch(IveriSubmission(quote)),
        dispatchShowChangeCreditCard: () => dispatch(showChangeCreditCard()),
        dispatchGetLifeBankingDetailsPage: (count: number, skip: number, more?: boolean) => dispatch(getLifeBankingDetailsPage(count, skip, more)),
        dispatchGetSpecialDebitDays: () => dispatch(getSpecialDebitDays()),
        dispatchSetCollectionToSchedule: (id) => dispatch(setCollectionToSchedule(id)),
        dispatchSaveBankingDetails: (bankingDetails) => dispatch(saveBankingDetails(bankingDetails)),
        dispatchAvsValidateBankingDetails: (bankingDetails) => dispatch(avsValidateBankingDetails(bankingDetails)),
        dispatchPersistDebitOrderDate: (date, text) => dispatch(updateDebitOrderDate(date, text)),
        dispatchSubmitScheduleSpecialDebit: (date) => dispatch(submitScheduleSpecialDebit(date)),
        dispatchResetMetadata: () => dispatch(clearMetadata()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifePaymentDeets);